/**
 * @whatItDoes This service acts on HTTP requests in the interceptor chain to handle a 401. See
 * https://angular.io/api/common/http/HttpInterceptor for more information on HTTP Interceptors
 */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SystemEventsService } from '../../services';
import { SystemEventConstants } from '../../constants';
import { SystemEvent } from '../../events';
import { SystemMaintenanceException, VersionDeprecatedException } from '../../exceptions';

@Injectable()
export class SystemEventsInterceptor implements HttpInterceptor {
  constructor(private systemUpdateEventsService: SystemEventsService) {}

  /**
   * Implementing intercept() takes in the request to be handled and if
   * an authentication token exists in localStorage, attaches it to the
   * headers in the correct field
   *
   * @param request the outgoing HttpRequest
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /* istanbul ignore next */
    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof SystemMaintenanceException) {
          this.systemUpdateEventsService.sendSystemEvent(new SystemEvent(SystemEventConstants.SYSTEM_MAINTENANCE, err.message));
          return EMPTY;
        }

        if (err instanceof VersionDeprecatedException) {
          this.systemUpdateEventsService.sendSystemEvent(new SystemEvent(SystemEventConstants.VERSION_DEPRECATED, err.message));
          return EMPTY;
        }

        return throwError(() => err);
      })
    );
  }
}
